<template>
    <div>
        <v-alert dense border="bottom" type="primary" icon="mdi-information"
            >CASE INFORMATION</v-alert
        >
        <v-card-text>
            <v-container fluid>
                <v-row style="margin-bottom: -30px">
                    <v-col
                        cols="12"
                        sm="6"
                        :md="
                            condition.project == 'CDAX' ||
                            condition.project == 'SRFR'
                                ? 4
                                : 6
                        "
                    >
                        <v-textarea
                            class="caption"
                            v-model="information.case_title"
                            label="Case Title / Symptom"
                            filled
                            height="60"
                            outlined
                            :rules="casetitleRules"
                            required
                        ></v-textarea>
                    </v-col>
                    <v-col
                        v-if="
                            condition.project == 'CDAX' ||
                                condition.project == 'SRFR'
                        "
                        cols="12"
                        sm="6"
                        md="4"
                    >
                        <v-textarea
                            class="caption"
                            v-model="information.subcase_title"
                            label="อาการเสีย"
                            filled
                            height="60"
                            outlined
                            required
                        ></v-textarea>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="6"
                        :md="
                            condition.project == 'CDAX' ||
                            condition.project == 'SRFR'
                                ? 4
                                : 6
                        "
                    >
                        <v-textarea
                            class="caption"
                            v-model="information.remark"
                            label="Remark"
                            filled
                            height="60"
                            outlined
                        ></v-textarea>
                    </v-col>
                </v-row>
                <v-row style="margin-bottom: -20px">
                    <v-col cols="12" sm="6" md="2">
                        <v-menu
                            v-model="datemenucreate"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="computedDateFormatted2"
                                    label="Date Created"
                                    hint="MM/DD/YYYY format"
                                    dense
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="datecreate"
                                no-title
                                @input="datemenucreate = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-menu
                            ref="menu"
                            v-model="timemenucreate"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="timecreate"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="information.case_create_time"
                                    label="Time Created"
                                    readonly
                                    dense
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-time-picker
                                v-if="timemenucreate"
                                v-model="information.case_create_time"
                                full-width
                                format="24HR"
                                @click:minute="$refs.menu.save(timecreate)"
                            ></v-time-picker>
                        </v-menu>
                    </v-col>

                    <v-col cols="12" sm="6" md="2">
                        <v-select
                            class="caption"
                            :items="SLA"
                            label="SLA"
                            v-model="information.case_sla"
                            dense
                            :rules="caseSLARules"
                            required
                        ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-menu
                            v-model="datemenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="computedDateFormatted"
                                    label="Date SLA"
                                    hint="MM/DD/YYYY format"
                                    readonly
                                    dense
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="date"
                                no-title
                                @input="datemenu = false"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-menu
                            ref="menu"
                            v-model="timemenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="time"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="information.case_sla_time"
                                    label="Time SLA"
                                    readonly
                                    dense
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-time-picker
                                v-if="timemenu"
                                v-model="information.case_sla_time"
                                full-width
                                format="24HR"
                                @click:minute="$refs.menu.save(time)"
                            ></v-time-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-select
                            class="caption"
                            v-if="condition.team != 'NONHP'"
                            :items="special"
                            label="Special Status"
                            v-model="information.special_status"
                            dense
                            clearable
                        ></v-select>
                        <v-select
                            class="caption"
                            v-if="condition.team == 'NONHP'"
                            :items="CSR"
                            label="CSR"
                            v-model="information.case_csr"
                            dense
                        ></v-select>
                    </v-col>
                </v-row>
                <v-row style="margin-bottom: -20px">
                    <v-col
                        v-if="condition.team == 'NONHP'"
                        cols="12"
                        sm="6"
                        md="2"
                    >
                        <v-select
                            class="caption"
                            label="Project"
                            v-model="information.project_id"
                            dense
                            :items="projectnonhp"
                            item-text="project_name"
                            item-value="project_id"
                        ></v-select>
                    </v-col>
                    <v-col
                        v-if="condition.team == 'NONHP'"
                        cols="12"
                        sm="6"
                        md="4"
                    >
                        <v-text-field
                            label="Refer Case"
                            dense
                            v-model="information.case_refer"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-select
                            class="caption"
                            :items="information.problem_type"
                            item-text="problem_type_name"
                            item-value="problem_type_id"
                            v-model="information.case_problem_type"
                            label="Problem Type"
                            dense
                            :rules="[(v) => !!v || 'ProblemType is required']"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-select
                            class="caption"
                            :items="jobtype"
                            v-model="information.case_type"
                            label="Jobtype"
                            dense
                            :rules="jobtypeRules"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-text-field
                            v-if="information.case_type == 'benchO'"
                            label="CE Owner Case"
                            v-model="information.ce_bencho"
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col
                        v-if="condition.team != 'NONHP'"
                        cols="12"
                        sm="6"
                        md="2"
                        style="margin-top: -25px"
                    >
                        <v-radio-group v-model="information.warranty_type" row>
                            <v-radio
                                class="caption"
                                label="In Warranty"
                                value="IW"
                            ></v-radio>
                            <v-radio
                                class="caption"
                                label="Out Warranty"
                                value="OOW"
                            ></v-radio>
                        </v-radio-group>
                    </v-col>

                    <v-col
                        v-if="condition.project == 'CDAX'"
                        cols="12"
                        sm="6"
                        md="2"
                        style="margin-top: -25px"
                    >
                        <v-radio-group v-model="chk_quotation" row>
                            <v-radio
                                label="ไม่มีใบเสนอราคา"
                                value="N"
                                dense
                            ></v-radio>
                            <v-radio label="มีใบเสนอราคา" value="Y"></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col
                        v-if="condition.project == 'CDAX'"
                        cols="12"
                        sm="6"
                        md="2"
                    >
                        <v-select
                            v-if="chk_quotation == 'Y'"
                            label="สถานะใบเสนอราคา"
                            v-model="information.quotation_check"
                            dense
                            :items="quotation"
                        ></v-select>
                    </v-col>
                </v-row>
                <v-row style="margin-bottom: -30px">
                    <v-col
                        v-if="
                            condition.team == 'NONHP' &&
                                information.is_special == 'Y'
                        "
                        cols="12"
                        sm="6"
                        md="2"
                    >
                        <v-text-field
                            label="HP Case ID"
                            v-model="information.case_hp"
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col
                        v-if="
                            condition.team == 'NONHP' &&
                                information.is_special == 'Y'
                        "
                        cols="12"
                        sm="6"
                        md="4"
                        style="margin-top: -15px"
                    >
                        <v-radio-group
                            :rules="
                                information.case_hp &&
                                (information.case_hp != '' ||
                                    information.case_hp != undefined)
                                    ? caseTypeR
                                    : ''
                            "
                            v-model="information.case_hptype"
                            row
                        >
                            <v-radio label="Claim" value="Claim"></v-radio>
                            <v-radio label="Onsite" value="Onsite"></v-radio>
                            <v-radio
                                label="Software"
                                value="Software"
                            ></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col
                        v-if="condition.team == 'SVC'"
                        cols="12"
                        sm="6"
                        md="2"
                    >
                        <v-checkbox
                            v-model="information.send_bkk"
                            label="Send To Bkk"
                            dense
                            style="margin-top: -20px"
                        ></v-checkbox>
                    </v-col>
                    <v-col
                        v-if="condition.team == 'Bench' && send_status !== null"
                        cols="12"
                        sm="6"
                        md="2"
                    >
                        <v-checkbox
                            v-model="information.send_uc"
                            label="Send To UC"
                            dense
                            style="margin-top: -20px"
                        ></v-checkbox>
                    </v-col>
                    <v-col
                        v-if="
                            condition.project == 'ODM' &&
                                condition.team == 'SVC'
                        "
                        cols="12"
                        sm="6"
                        md="4"
                        style="margin-top: -20px"
                    >
                        <v-select
                            class="caption"
                            label="OTC"
                            v-model="information.otc"
                            dense
                            :items="warranty_code"
                            item-text="warranty_name"
                            item-value="warranty_val"
                        ></v-select>
                    </v-col>
                </v-row>

                <!-- CUSTOMER INFO -->
                <v-row style="margin-bottom: -30px">
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field
                            class="caption"
                            v-model="information.customer_name"
                            label="Name"
                            :rules="[(v) => !!v || 'Customer Name is required']"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="3" md="3">
                        <v-text-field
                            class="caption"
                            v-model="information.customer_tel"
                            label="Telephone"
                            :rules="[(v) => !!v || 'Customer Tel is required']"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="3" md="3">
                        <v-text-field
                            class="caption"
                            v-model="information.customer_email"
                            label="Email"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="3" md="1"> </v-col>
                    <v-col cols="6" sm="3" md="2">
                        <v-text-field
                            v-if="
                                condition.project == 'CDAX' ||
                                    condition.project == 'S-Print'
                            "
                            class="caption"
                            v-model="information.wonumber"
                            label="WO Number"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <!-- PRODUCT INFO -->
                <v-row style="margin-bottom: -30px">
                    <v-col cols="12" sm="6" md="2">
                        <v-text-field
                            class="caption"
                            @blur="getKbankToner()"
                            v-model="information.product_serial"
                            label="Serial No"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-text-field
                            class="caption"
                            v-model="information.product_line"
                            label="Product Line"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-text-field
                            class="caption"
                            v-model="information.product_no"
                            label="Product No"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            class="caption"
                            v-model="information.product_description"
                            label="Product Description"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="2" style="margin-top: -15px">
                        <v-radio-group v-model="information.product_group" row>
                            <v-radio
                                label="Computing"
                                value="Computing"
                            ></v-radio>
                            <v-radio
                                label="Printing"
                                value="Printing"
                            ></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col
                        v-if="
                            condition.project == 'CDAX' &&
                                (team_name == 'IPG' ||
                                    team_name == 'PSG' ||
                                    team_name == 'SUPPORTUC')
                        "
                        cols="12"
                        sm="6"
                        md="2"
                        style="margin-top: -25px"
                    >
                        <v-switch
                            v-model="information.sms_status"
                            color="primary"
                            label="ส่ง SMS หาลูกค้า"
                            value="Y"
                            hide-details
                            disabled
                        ></v-switch>
                    </v-col>

                    <v-col
                        v-if="
                            condition.project == 'CDAX' &&
                                (team_name == 'IPG' ||
                                    team_name == 'PSG' ||
                                    team_name == 'SUPPORTUC') &&
                                information.sms_status == 'Y'
                        "
                        cols="12"
                        sm="6"
                        md="4"
                        style="margin-top: -25px"
                    >
                        <v-radio-group
                            v-model="information.sms_language"
                            :rules="sms_languageR"
                            row
                        >
                            <v-radio
                                label="ส่ง SMS ภาษาไทย"
                                value="th"
                            ></v-radio>
                            <v-radio
                                label="ส่ง SMS ภาษาอังกฤษ"
                                value="en"
                            ></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios"

export default {
    props: ["information", "condition"],
    //   mounted() {
    //     this.$refs.form.validate();
    //   },
    beforeMount() {
        // console.log(this.information, "-information")
        console.log("[Information] beforeMount — condition.project:", this.condition.project)
        console.log("[Information] beforeMount — information.project_id:", this.information.project_id)
        console.log("[Information] beforeMount — information.problem_type:", this.information.problem_type)
        const today = new Date()
        const time =
            today.getHours() +
            ":" +
            (today.getMinutes() < 10 ? "0" : "") +
            today.getMinutes()
        this.information.case_create_time = time
        this.information.case_sla_time = time
        if (this.condition.team == "NONHP") {
            this.getprojectnonhp()
        }
        // console.log(this.information.project_id, "-project id")
        this.SLA =
            (this.condition.team == "NONHP" ||
                localStorage.role_name != "MPS") &&
            this.information.sla_new !== undefined &&
            this.information.sla_new.length > 0 &&
            this.information.project_id != "134"
                ? [...this.information.sla_new]
                : this.information.project_id == "134"
                ? ["24 Hours", "NBD"]
                : [
                      "2 Hours",
                      "3 Hours",
                      "4 Hours",
                      "5 Hours",
                      "6 Hours",
                      "8 Hours",
                      "12 Hours",
                      "24 Hours",
                      "48 Hours",
                      "NCD",
                      "NBD",
                      "3 Days",
                      "N/A",
                  ]
        // console.log(this.SLA, "-SLA")

        var chkteam = ["ODM", "BKK"]  
            if (this.condition.team == "NONHP") {
                this.information.case_type = "Onsite Repair"
                this.information.case_csr = "C"
            } else if (this.condition.team == "Uc") {
                this.information.case_type = "Onsite Repair"
            } else if (chkteam.indexOf(this.condition.team) != -1) {
                if (this.information.special_type == "Claim") {
                    this.information.case_type = "Claim"
                } else if (this.information.special_type == "Software") {
                    this.information.case_type = "Software"
                } else {
                    this.information.case_type = "Onsite Repair"
                }
            } else if (
                this.condition.team == "SVC" ||
                this.condition.team == "Bench"
            ) {
                this.information.case_type = "bench"
            }
        if (this.information.case_sla == "" && this.condition.team != "NONHP") {
            this.information.case_sla = "NBD"
        }
        if (
            this.condition.status != "editcase" &&
            this.information.case_id[0] == "B"
        ) {
            this.information.case_problem_type = "3"
        } else if (
            this.condition.status != "editcase" &&
            this.information.case_id[0] != "B" &&
            this.condition.team != "Inv"
        ) {
            this.information.case_problem_type = "4"
        }

        this.information.warranty_type =
            this.information.otc_code == "01-Trade" ? "OOW" : "IW"
        this.information.case_hp = ""

        // this.information.skip_ismart == "Y"
        //     ? (this.information.skip_ismart = "Y")
        //     : (this.information.skip_ismart = "N")
        // this.information.skip_ismart = "Y"
    },
    watch: {
        // whenever question changes, this function will run
        "information.case_title": function(newQuestion, oldQuestion) {
            if (this.information.case_sla_datetime === null) {
                this.information.case_sla_time = "00:00"
            } else {
                var text = this.information.case_sla_datetime.split(" ")
                this.date = this.formatDate(text[0])
                this.information.case_sla_time = text[1].substring(0, 5)
            }
        },
    },
    data() {
        return {
            team_name: localStorage.team_name,
            dialog_loading: false,
            jobtype: ["Onsite Repair", "bench", "benchO", "Claim", "Software"],
            Probtype: [],
            CSR: ["A", "B", "C"],
            quotation: ["Pending", "Approved", "Rejected"],
            special: ["CRT", "update warranty", "uncontrol"],
            SLA: [],
            date: new Date().toISOString().substr(0, 10),
            time: null,
            timemenu: false,
            datemenu: false,
            datecreate: new Date().toISOString().substr(0, 10),
            timecreate: null,
            timemenucreate: false,
            datemenucreate: false,
            casetitleRules: [(v) => !!v || "CaseTitle is required"],
            jobtypeRules: [(v) => !!v || "CaseTitle is required"],
            caseSLARules: [(v) => !!v || "SLA is required"],
            caseTypeR: [(v) => !!v || "Case Type is required"],
            sms_languageR: [(v) => !!v || "SMS Language is required"],
            snackbar: true,
            engineer: [],
            chk_quotation: "",
            warranty_code: [
                {
                    warranty_name: "Trade Call , No Warranty, No Contract",
                    warranty_val: "01E",
                },
                {
                    warranty_name: "Warranty",
                    warranty_val: "02N",
                },
                {
                    warranty_name: "Support Pack / Carepaq",
                    warranty_val: "05K",
                },
                {
                    warranty_name: "Re-repair ( no charge)",
                    warranty_val: "06M",
                },
            ],
            projectnonhp: [],
        }
    },
    methods: {
        formatDate(date) {
            if (!date) return null
            const [year, month, day] = date.split("-")
            return `${year}-${month}-${day}`
        },
        async getKbankToner() {
            if (
                this.information.project_id == "54" ||
                this.information.project_id == "56"
            ) {
                const url = `${process.env.VUE_APP_ROOT_API}/api/search-master-data`
                const body = {
                    search: this.information.product_serial,
                    project_name: this.condition.project,
                }
                const { data } = await axios.post(url, body)
                this.information.site_name = data.branchName
                this.information.site_address = data.address
                this.information.site_postcode =
                    data.postalcode !== undefined ? data.postalcode : ""
                this.information.customer_name = data.managerName
                this.information.customer_tel = data.tel
                this.information.product_group = "Printing"
                this.information.product_line = "Printer"
                this.information.product_no =
                    "Printer HP LaserJet Pro MFP M426m"
                this.information.product_description =
                    "Printer HP LaserJet Pro MFP M426m"
                // this.information.remark = `${data.HostName} ${data.macaddress} ${data.IP}`;
                this.information.remark = data.remark
            }
            // else if (this.information.project_id == "177") {
            //     //Leeka - 7Eleven
            //     this.dialog_loading = true
            //     const url = `${process.env.VUE_APP_ROOT_API}/api/search-master-data`
            //     const body = {
            //         search: this.information.product_serial,
            //         project_name: this.condition.project,
            //     }
            //     await axios
            //         .post(url, body)
            //         .then((response) => {
            //             console.log(response.data, "--test res 177")
            //             let product_line =
            //                 response.data.product_line == "Printer"
            //                     ? "Printing"
            //                     : response.data.product_line == "Computer"
            //                     ? "Computing"
            //                     : ""
            //             //Add Data
            //             this.information.site_name = response.data.branchName
            //             this.information.site_address = response.data.address
            //             this.information.site_postcode =
            //                 response.data.postalcode !== undefined
            //                     ? response.data.postalcode
            //                     : ""
            //             this.information.customer_name =
            //                 response.data.managerName
            //             this.information.customer_tel = response.data.tel
            //             this.information.product_group = product_line
            //             this.information.product_line =
            //                 response.data.product_line
            //             this.information.product_no = response.data.product_no
            //             this.information.product_description =
            //                 response.data.product_description
            //             this.information.remark =
            //                 response.data.remark !== undefined
            //                     ? response.data.remark
            //                     : ""

            //             this.dialog_loading = false
            //         })
            //         .catch((error) => {
            //             console.log(error)
            //         })
            // }
        },
        async getprojectnonhp() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/report/filter`
            try {
                const { data } = await axios.get(`${url}`, options)
                this.projectnonhp = data.project
            } catch (error) {
                console.log(error)
            }
        },

        //   async getCEBenchO() {
        //     if (this.information.case_type == "benchO") {
        //       const url = `${process.env.VUE_APP_ROOT_API}/api/engineer-list`;
        //       const options = {
        //         headers: {
        //           Authorization: "Bearer " + localStorage.token,
        //         },
        //       };
        //       const { data } = await axios.get(`${url}`, options);
        //       this.engineer = data;
        //     }
        // },
    },
    computed: {
        computedDateFormatted() {
            this.information.case_sla_date = this.formatDate(this.date)
            return this.information.case_sla_date
        },
        computedDateFormatted2() {
            this.information.case_create_date = this.formatDate(this.datecreate)
            return this.information.case_create_date
        },
    },
}
</script>
<style scoped>
.v-snack__wrapper {
    min-width: 290px !important;
    max-width: 672px !important;
}
v-radio >>> div.v-radio {
    width: 100px !important;
    margin-right: 50px !important;
}
.v-radio >>> label {
    font-size: small;
}
.v-radio >>> div.v-input--selection-controls__input {
    transform: scale(0.7) !important;
}
</style>
